import React from 'react';
import './Pelicula.css';

const Pelicula = () => (
  <div>
    <h2>PELÍCULA</h2>

    <div className='embed-wrapper'>
      <iframe
        src='https://player.vimeo.com/video/482714460'
        title='La Otra Isla'
        width='640'
        height='360'
        frameBorder='0'
        allow='autoplay; fullscreen'
        allowFullscreen
      />
    </div>

    <p>
      Artistas y otros protagonistas del arte cubanos, hablan desde su
      experiencia sobre el medio artístico contemporáneo en la isla y los retos
      a los que se enfrentan como productores culturales entre la constante e
      inevitable relación con el estado y los proyectos independientes.
    </p>
    <p>
      El documental La otra isla es un acercamiento al arte contemporáneo cubano
      a partir de reflexiones diversas en torno a la política cultural en Cuba
      desde los años 90 hasta la actualidad. Estructurado bajo distintos ejes
      temáticos que van desde la particularidad de la formación artística
      oficial, la importancia de proyectos pedagógicos alternativos o el papel
      de la Bienal de la Habana y de plataformas independientes como la Bienal
      00, hasta las lógicas institucionales, la legislación reciente con
      respecto a la producción y promoción artística, la censura y la
      reivindicación de la comunidad artística a favor de la libertad de
      expresión.
    </p>

    <p>
      El título es una referencia al documental de 1968 &quot;En la otra
      isla&quot; de Sara Gómez, la primera directora de cine del Instituto
      Cubano de Arte e Industria Cinematográficos de Cuba (ICAIC).
    </p>
  </div>
);
export default Pelicula;
